import React from 'react';
import JPlayer, {
  initializeOptions, Gui,
  Audio, Title, Mute, Play, Poster,
  VolumeBar, CurrentTime, BrowserUnsupported,
} from 'react-jplayer';

const defaultOptions = {
  id: 'LivePlayer',
  keyEnabled: true,
  verticalVolume: true,
  autoplay: true,
  media: {
    title: 'Rádio Vital FM',
    sources: {
        mp3: 'https://vitalfm.jmvstream.com/stream'
    },
  }
};

// 'http://95.154.254.157/stream.mp3?ipport=95.154.254.157_30659',
// 

initializeOptions(defaultOptions);

const LivePlayer = () => (
  <JPlayer id={defaultOptions.id} className="jp-sleek">
    <Audio />
    <Gui>
      <Poster />
      <div className="jp-controls jp-icon-controls">
        <Play><i className="fas fa-play">{/* Icon set in css */}</i></Play>
        <div className="jp-progress">
          <CurrentTime />
        </div>
        <div className="jp-volume-container">
          <Mute>
            <i className="fas fa-volume-off">{/* Icon set in css */}</i>
          </Mute>
          <div className="jp-volume-slider">
            <div className="jp-volume-bar-container">
              <VolumeBar />
            </div>
          </div>
        </div>
        <div className="jp-title-container">
          <Title />
        </div>
      </div>
      <BrowserUnsupported />
    </Gui>
  </JPlayer>
);

export default LivePlayer;



// WEBPACK FOOTER //
// ./src/livePlayer.jsx